import { z } from 'zod';

/** Name of the idempotency header, lower case as Fastify and `Headers` expose it (master X3). */
export const IDEMPOTENCY_KEY_HEADER = 'idempotency-key';

/**
 * Client-chosen UUID v4, one per user intent, and resent unchanged on retry (master X3).
 * The same key with the same body replays the stored response. A different body answers 409.
 */
export const IdempotencyKeySchema = z
  .uuidv4()
  .describe('UUID v4 chosen by the client per user intent; resent unchanged on retry (master X3).');

/** Header object of every write route. Non-strict: other headers are allowed. */
export const IdempotencyHeadersSchema = z.object({
  [IDEMPOTENCY_KEY_HEADER]: IdempotencyKeySchema,
});

/** `Bearer <token>` with RFC 6750 token characters. */
export const BEARER_PATTERN = /^Bearer [A-Za-z0-9\-._~+/]+=*$/;

/** Authorization header of every protected route (master X1). */
export const AuthorizationHeaderSchema = z.object({
  authorization: z.string().regex(BEARER_PATTERN, 'Expected "Bearer <token>"'),
});
